import '@babel/polyfill';
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueCropper from 'vue-cropper'


import './assets/css/common.scss';
import {
  Aside,
  Autocomplete,
  Avatar,
  Backtop,
  Breadcrumb,
  BreadcrumbItem,
  Button,
  Calendar,
  Carousel,
  CarouselItem,
  Checkbox,
  CheckboxGroup,
  Col,
  Collapse,
  CollapseItem,
  container,
  DatePicker,
  Dialog,
  Divider,
  Drawer,
  dropdown,
  dropdownItem,
  dropdownMenu,
  Footer,
  Form,
  FormItem,
  Header,
  Input,
  InputNumber,
  Link,
  Loading,
  Main,
  Menu,
  MenuItem,
  MenuItemGroup,
  Message,
  MessageBox,
  Option,
  Pagination,
  Popconfirm,
  Popover,
  Radio,
  RadioButton,
  RadioGroup,
  Row,
  Select,
  Step,
  Steps,
  Submenu,
  Switch,
  Table,
  TableColumn,
  TabPane,
  Tabs,
  Tag,
  Tooltip,
  Transfer,
  Upload,
  Image,
  ColorPicker, Badge, Notification, CheckboxButton,
  Slider,
  InfiniteScroll

} from 'element-ui'

import 'element-ui/lib/theme-chalk/base.css';
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';

import Es6Promise from 'es6-promise'
import base from './api/common';
import common from './api/common';
import qs from "qs";

/*import loadmore from './loadmore'
Vue.use(loadmore)*/

import vcolorpicker from 'vcolorpicker'

Vue.use(vcolorpicker)

Vue.use(Carousel).use(CarouselItem).use(Button).use(Upload).use(Form).use(Drawer)
    .use(Calendar).use(FormItem).use(Input).use(Tabs).use(TabPane).use(Pagination)
    .use(Select).use(Option).use(Table).use(TableColumn).use(Breadcrumb).use(BreadcrumbItem)
    .use(Radio).use(RadioGroup).use(RadioButton).use(Dialog).use(Avatar).use(Popconfirm)
    .use(Popover).use(Divider).use(Loading).use(Checkbox).use(Link).use(Backtop).use(Steps)
    .use(Step).use(DatePicker).use(Collapse).use(CollapseItem).use(Transfer).use(Tag)
    .use(InputNumber).use(Row).use(Col).use(CheckboxGroup).use(Switch).use(VueCropper)
    .use(Header).use(Aside).use(Main).use(Footer).use(Menu).use(Submenu).use(MenuItem)
    .use(MenuItemGroup).use(dropdown).use(dropdownItem).use(dropdownMenu).use(Tooltip)
    .use(Autocomplete).use(Image).use(ColorPicker).use(Badge).use(container).use(Slider)
    .use(CheckboxButton).use(InfiniteScroll).component(CollapseTransition.name, CollapseTransition);

// const isPass = (url) => {
//     let passUrls = ['/login', '/logout'];
//     return passUrls.some((item) => {
//         return url.indexOf(item) > -1;
//     })
// };
axios.defaults.withCredentials = true;
axios.interceptors.request.use((config) => {
  let url = config.url;
  // console.log(url,/(uthorize\/)+/g.test(url))
  // if (isPass(url)) {
  // console.log("url>>>", url, /(authorize\/)+|(logout)+|(\/admin\/)+/.test(url))
  if (!/(authorize\/)+|(authorize)+|(logout)+|(\/admin\/)+/.test(url)) {
    return config;
  }
  if (localStorage.access_token) {
    config.headers["Authorization"] = "bearer " + localStorage.access_token
  }
  return config
}, (error) => {
  return Promise.reject(error)
});

let _reg = ""; // 抛异常路径
// let _reg = /(article-banner\/authorize\/list\/doctor)+/g;

let api_pass_401 = [
  /(researches\/authorize\/details)+/ // 每日研究详情
  , /(article\/sciences\/authorize\/\w+\/liked)+/ // 公益科普详情
  , /(experts\/lecture\/authorize\/list\/page)+/ // 讲座
  , /(communication\/comm-chat-message\/authorize\/unread\/total)+/ // 未读消息
  , /(communication\/comm-visit-history\/authorize\/visits)+/ // 统计
  , /(corp\/corp-exam\/authorize\/details-exam\/)+/

];
let fail_401_count = 0;
let fail_refresh_count = 0;

axios.interceptors.response.use((response) => {
  return response;
}, (error => {
  if (error.response) {
    if (error.config.url.endsWith('/login')) {
      return error.response;
    } else if (error.response.status == 401) {
      for (let i = 0; i < api_pass_401.length; i++) {
        if (api_pass_401[i].test(error.config.url)) {
          throw error;
        }
      }
    }

    if (error.response.status == 401) {
      let refresh_token = localStorage.getItem("refresh_token");
      if (!refresh_token) {
        MessageBox.alert('请重新登录', '', {
          confirmButtonText: '确定',
          callback: action => {
            router.push('/login')
          }
        }).then(() => {
          router.push('/login')
        });
        // throw error;
        return;
      }

      //1.尝试重新获取accessToken
      let params = {
        grant_type: 'refresh_token',
        scope: 'all',
        client_id: 'web',
        client_secret: 'secret',
        refresh_token: refresh_token,
      };
      if (fail_401_count > 1 || fail_refresh_count > 0) {
        return;
      }
      axios.post(base.api.login, qs.stringify(params)).then(rest => {
        if (rest.data.access_token) {
          // 清除旧信息
          localStorage.clear();
          localStorage.setItem("access_token", rest.data.access_token);
          localStorage.setItem("expires_in", rest.data.expires_in);
          localStorage.setItem("refresh_token", rest.data.refresh_token);
          localStorage.setItem("get_token_date", new Date().getTime());
          fail_401_count = 0;
          fail_refresh_count = 0;
          // 获取新信息
          axios.post(base.api.current).then(res => {
            if (res.data.status === 'success') {
              localStorage.setItem("curUid", res.data.data.uid);
              localStorage.setItem("name", res.data.data.name);
              localStorage.setItem("headImg", res.data.data.img);
              localStorage.setItem("account", res.data.data.account);
              localStorage.setItem("user_type", res.data.data.type);

              location.reload();
            }
          });
          // 刷新页面
          return;
        } else {
          fail_refresh_count++;
          throw error;
        }
      }).catch(err => {
        //2.获取失败
        localStorage.clear();
        if (fail_401_count > 1 || fail_refresh_count > 0) {
          return;
        }
        fail_401_count++;
        fail_refresh_count++;
        MessageBox.alert('请重新登录', '', {
          confirmButtonText: '确定',
          callback: action => {
            fail_401_count = 0;
            router.push('/login')
          }
        });
      });
    } else if (error.response.status == 403) {
      MessageBox.alert('无访问权限');
    }
  }
  return error.response;
}));

Vue.prototype.$ajax = axios;
Vue.prototype.$message = Message;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$messageBox = MessageBox;
Vue.prototype.$notify = Notification;

Vue.config.productionTip = false;

import routerHandle from "@/api/router_handle";

router.beforeEach(async (to, from, next) => {
  routerHandle.handleClientAdapter(to, window.location);

  if (to.meta.type && to.meta.type == 'doctorIndex') {// 先判断是否有该医生信息，没有跳回首页
    const status = await axios.post(common.api.doctor.exist.replace('{account}', to.params.account))
        .then((res) => {
          return res.data.status
        });
    if (status == 'fail') {// 获取不到医生信息，跳回首页
      next('/index')
      return
    }
  }

  if (/\/admin\//.test(to.path) && !to.path.endsWith('/login')) {// 后台管理路径，判断当前用户是否为管理员
    // console.log('后台路径：', to.path);
    if (localStorage.access_token) {
      axios.get(base.basePath + "/sys/current", {headers: {"Authorization": "bearer " + localStorage.access_token}})
          .then((res) => {
            if (res.data && res.data.type == 3) {
              next();
              // console.log('管理员账号', res.data.type)
            } else {
              // console.log('普通账号', res.data.type)
              next('/index')
              return
            }
          })
    } else {
      next('/admin/login?unauthorize')
      return
    }
    next()
  } else if (/\/user\/|\/doctor\/|\/chat\//.test(to.path)) {
    if ('doctorIndex' == to.name) {
      next();
      return;
    }
    if (localStorage.access_token) {
      axios.get(base.basePath + "/sys/current", {headers: {"Authorization": "bearer " + localStorage.access_token}})
          .then((res) => {
            if (res.data && res.data.type) {
              next();
            } else {
              next('/login');
            }
          })
    }
  } else {
    next();
  }
})

Date.prototype.parseDate = function (date) {
  let {userAgent} = window.navigator;
  if (userAgent.includes('Safari')) {
    if (typeof date === 'string') {
      return new Date(date.replace(/-/g, '/'));
    }
    return new Date(date);
  }
  return new Date(date);
}

Date.prototype.Format = function (fmt) {
  let o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "H+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S": this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
};
/** @return {string} */
Date.prototype.FirstDay = function () {
  let year = this.getFullYear();
  let month = this.getMonth() + 1;
  if (month < 10) {
    month = '0' + month;
  }
  return year + '-' + month + '-01'
};

/** @return {string} */
Date.prototype.LastDay = function () {
  let year = this.getFullYear();
  let month = this.getMonth() + 1;
  if (month < 10) {
    month = '0' + month;
  }
  let lastDateOfCurrentMonth = new Date(year, month, 0);

  let day = lastDateOfCurrentMonth.getDate();
  if (day < 10) {
    day = '0' + day;
  }
  return year + '-' + month + '-' + day;
};

/* ------------------- */
// import VueSocketIo from 'vue-socket.io';
// Vue.use(new VueSocketIo({
//     debug: true, // 生产环境建议关闭，开发环境可以打开
//     connection: 'https://localhost'
// }))

Es6Promise.polyfill();
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
